import React, { useState, useEffect } from 'react'
import "./Hero.css"
import hero_image from "../../assets/hero_image.png"
import hero_back from "../../assets/hero_image_back.png"
import heart from "../../assets/heart.png"
import calories from "../../assets/calories.png"
import { motion } from "framer-motion"
import NumberCounter from "number-counter";
import Header from '../Header/Header'
import { Link } from "react-scroll";

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);
  const transition = { duration: 3, type: "spring" };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="hero" id='home'>
      <div className="blur hero-blur"></div>

      <div className="left-h">
        <Header/>
        <div className="the-best" data-aos="fade-right" data-aos-delay="200">
          <motion.div
            initial={{left: isMobile ? "178px" : '238px' }}
            whileInView={{ left: "8px" }}
            transition={{ ...transition, type: "tween" }}
          ></motion.div>
          <span>THE BEST FITNESS CLUB IN THE TOWN</span>
        </div>
        <div className="hero-text">
          <div data-aos="fade-up" data-aos-delay="300">
            <span className="stroke-text">Shape </span>
            <span>Your</span>
          </div>
          <div data-aos="fade-up" data-aos-delay="400">
            <span>Ideal body</span>
          </div>
          <div data-aos="fade-up" data-aos-delay="500">
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to fullest
            </span>
          </div>
        </div>

        <div className="figures" data-aos="fade-up" data-aos-delay="600">
          <div>
            <span>
              <NumberCounter end={140} start={100} delay={4} preFix="+" />
            </span>
            <span>expert coaches</span>
          </div>
          <div>
            <span>
              <NumberCounter end={978} start={878} delay={4} preFix="+" />
            </span>
            <span>Members joined</span>
          </div>
          <div>
            <span>
              <NumberCounter end={50} delay={2} preFix="+" />
            </span>
            <span>fitness programs</span>
          </div>
        </div>

        <div className="hero-btns" data-aos="fade-up" data-aos-delay="700">
          <button className="btn">Get Started</button>
          <button className="btn">Learn More</button>
        </div>
      </div>

      <div className="right-h">
      <Link className="btn"
              to="contact"
              spy={true}
              smooth={true}
            >
              Join now
            </Link>

        <motion.div
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
          transition={transition}
          className="heart-rate"
          data-aos="fade-left" data-aos-delay="400"
        >
          <img src={heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>

        <img className="hero-img" src={hero_image} alt="" data-aos="zoom-in" data-aos-delay="500" />
        <motion.img
            initial={{right: isMobile ? "2rem" : '11rem' }}
          whileInView={{ right: isMobile ? "2rem" : "20rem" }}
          transition={transition}
          className="hero-back"
          src={hero_back}
          alt=""
          data-aos="zoom-in" data-aos-delay="600"
        />

        <motion.div
          initial={{ right: "32rem" }}
          whileInView={{ right: "28rem" }}
          transition={transition}
          className="calories"
          data-aos="fade-up" data-aos-delay="700"
        >
          <img src={calories} alt="" />
          <div>
            <span>Calories burned</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
